import React, { Component } from "react";
import "./styles.css";
import Icon        from "../../prefabs/icon/view";
import PriceTicker from "../price-ticker/view";

class FloatingFooter extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.scrollToTop  = this.scrollToTop.bind(this);
    this.handleClick  = this.handleClick.bind(this);
    this.onClickLeft  = this.onClickLeft.bind(this);
    this.onClickRight = this.onClickRight.bind(this);



    this.navs = this.props.items.slice();
    this.navs.shift();  // Remove "intro"

    this.firstSlide = 0;
    this.lastSlide  = this.props.items.length - 1;
  }



  // ===============================================================================================
  scrollToTop(cb) {
    document.querySelector('.swiper-container-scroll-anchor').scrollIntoView({
      behavior: 'smooth',
      block:    'start',
    });
    cb();
  }



  // ===============================================================================================
  handleClick(clickedItem) {
    // console.log(`FOOTER:\n Clicked ${clickedItem} (${this.props.items[clickedItem].id})`);
    this.props.handleChange(clickedItem);
  }



  // ===============================================================================================
  onClickLeft(e) {
    e.preventDefault();
    if (this.props.activeSlide !== this.firstSlide) {
      // console.log(`FOOTER:\n Clicked previous slide`);
      this.scrollToTop(() => {
        this.props.handleChange(this.props.activeSlide - 1);
      });
    }
  }



  // ===============================================================================================
  onClickRight(e) {
    e.preventDefault();
    if (this.props.activeSlide !== this.lastSlide) {
      // console.log(`FOOTER:\n Clicked next slide`);

      // When clicking next on the package slide, save the number of kids as it might have changed due to location change
      // if (this.props.activeSlide >= 2) {
      //   if (this.props.sPackage.kids + this.props.sIntro.stars.length < this.props.sPackage.minCapacity) {
      //     this.props.sPackage.kids = this.props.sPackage.minCapacity - this.props.sIntro.stars.length
      //   }
      //   // console.log(this.props);
      // }
      this.scrollToTop(() => {
        this.props.handleChange(this.props.activeSlide + 1);
      });
    }
  }



  // ===============================================================================================
  render() {
        // ---------------------------------------------------------------------------------------------
    // Get current slide name (controls background colour in CSS)
    let slideName = null;
    if (this.props.items && this.props.items[this.props.activeSlide]) {
      slideName = this.props.items[this.props.activeSlide].id;
    }

    // ---------------------------------------------------------------------------------------------
    // Price display
    let viewPrices = [0, 0];

    if (this.props.price) {
      let iPrice = this.props.price;
      let sPrice = "" + iPrice;

      let priceOne = 0;
      let priceTwo = (iPrice < 10) ? "0" + sPrice : sPrice;

      if (iPrice > 99) {
        priceOne = sPrice.substring(0, sPrice.length-2);
        priceTwo = sPrice.substring(sPrice.length-2);
      }

      viewPrices[0] = parseInt(priceOne, 10) * 100;  // "Major", needs x100
      viewPrices[1] = parseInt(priceTwo, 10) * 10;   // "Minor", needs x10
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <nav className={"floating-footer" +
        ((this.props.hidden) ? " floating-footer--hidden" : "") +
        ((slideName) ? " floating-footer floating-footer--" + slideName : "")}>

        <div className="floating-footer__wrapper">



          <div className={"floating-footer__left" +
            ((this.props.activeSlide === this.firstSlide) ? " floating-footer__left--first" : "")}>
            <button
              className={"floating-footer__nav-btn floating-footer__nav-btn--left" +
                ((this.props.activeSlide === this.firstSlide) ? " floating-footer__nav-btn--inactive" : "")}
              tabIndex="-1"
              onClick={this.onClickLeft}>
              <Icon className="nav-arrow nav-arrow--left nav-arrow--sm" type="nav-left"   />
              <Icon className="nav-arrow nav-arrow--left nav-arrow--lg" type="nav-left-y" />
              <span className="nav-label nav-label--left"> Previous </span>
            </button>
          </div>



          <div className="floating-footer__middle">
            <div className={"floating-footer__price" +
              ((this.props.activeSlide === this.firstSlide) ? " floating-footer__price--hidden" : "")}>
              <span className="floating-footer__total">Total (Incl. GST)</span><br/>
              <span className="floating-footer__amount">
                <span className="amount-sign">$</span>
                <span className="amount-major">
                  <PriceTicker target={viewPrices[0]} type={"major"} />
                </span>
                <span className="amount-split">.</span>
                <span className="amount-minor">
                  <PriceTicker target={viewPrices[1]} type={"minor"} />
                </span>
                <span className="amount-disc Mcd_BPB__disclaimer-text">*</span>
              </span>
            </div>
          </div>



          <div className={"floating-footer__right" +
            ((this.props.activeSlide === this.firstSlide) ? " floating-footer__right--first" : "")}>
            <button
              className={"floating-footer__nav-btn floating-footer__nav-btn--right" +
                ((this.props.activeSlide === this.lastSlide) ? " floating-footer__nav-btn--inactive" : "")}
              tabIndex="-1"
              onClick={this.onClickRight}>
              <span className="nav-label nav-label--right"> Next </span>
              <Icon className="nav-arrow nav-arrow--right nav-arrow--sm" type="nav-left"   />
              <Icon className="nav-arrow nav-arrow--right nav-arrow--lg" type="nav-left-y" />
            </button>
          </div>



        </div>
      </nav>
    );
  }

}



export default FloatingFooter
